import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgSpain = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "M400 0H112C50.144 0 0 50.144 0 112v288c0 61.856 50.144 112 112 112h288c61.856 0 112-50.144 112-112V112C512 50.144 461.856 0 400 0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ffd250"
                },
                d: "M0 106.63h512v298.74H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "m223.091 256.412 8.255-33.665c.76-3.1-1.843-6.041-5.347-6.041h-5.815c-3.504 0-6.108 2.941-5.347 6.041l8.254 33.665z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M213.35 238.76h19.473v75H213.35z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M208.49 229.94h29.21v8.823h-29.21z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "M189.01 256.41h48.681v8.823H189.01zM237.696 291.706l-29.209-8.824v-8.823l29.209 8.823zM77.047 256.412l8.255-33.665c.76-3.1-1.843-6.041-5.347-6.041H74.14c-3.504 0-6.108 2.941-5.347 6.041l8.254 33.665z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M111.124 229.941c-5.377 0-9.736 3.95-9.736 8.824v57.353c0 10.721 11.041 30.882 48.682 30.882s48.682-20.162 48.682-30.882v-57.353c0-4.873-4.359-8.824-9.736-8.824h-77.892z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "M150.069 274.059h-48.682V239.21a9.27 9.27 0 0 1 9.269-9.269h39.413v44.118zM150.069 274.059h48.682v20.946c0 12.797-10.374 23.172-23.172 23.172h-2.338c-12.797 0-23.172-10.374-23.172-23.172v-20.946z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M101.387 274.059h48.682v20.946c0 12.797-10.374 23.172-23.172 23.172h-2.338c-12.797 0-23.172-10.374-23.172-23.172v-20.946z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "M140.333 313.665v-39.606h-9.736v43.673c3.62-.667 6.893-2.12 9.736-4.067zM120.86 317.732v-43.673h-9.736v39.606c2.843 1.947 6.115 3.4 9.736 4.067z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ffb441"
                },
                d: "M111.12 256.41h29.21v8.823h-29.21z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M111.12 238.76h29.21v8.824h-29.21z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M115.99 244.01h19.473v15.985H115.99z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M67.31 238.76h19.473v75H67.31z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M62.44 309.35h29.21v8.823H62.44zM62.44 229.94h29.21v8.823H62.44z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#5064aa"
                },
                d: "M57.57 318.18h38.945v8.823H57.57z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M213.35 309.35h29.21v8.823h-29.21z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#5064aa"
                },
                d: "M203.62 318.18h38.945v8.823H203.62z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M120.86 221.12h58.42v8.823h-58.42z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ffb441"
                },
                d: "M145.2 194.65h9.736v26.471H145.2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M140.333 207.882c-8.053 0-14.604-5.937-14.604-13.235s6.551-13.235 14.604-13.235c8.053 0 14.604 5.937 14.604 13.235s-6.551 13.235-14.604 13.235zm0-17.647c-2.686 0-4.868 1.978-4.868 4.412s2.182 4.412 4.868 4.412c2.686 0 4.868-1.978 4.868-4.412s-2.182-4.412-4.868-4.412z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M159.805 207.882c-8.053 0-14.604-5.937-14.604-13.235s6.551-13.235 14.604-13.235c8.053 0 14.604 5.937 14.604 13.235s-6.55 13.235-14.604 13.235zm0-17.647c-2.686 0-4.868 1.978-4.868 4.412s2.182 4.412 4.868 4.412c2.686 0 4.868-1.978 4.868-4.412s-2.182-4.412-4.868-4.412z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M179.278 216.706c-8.053 0-14.604-5.937-14.604-13.235s6.551-13.235 14.604-13.235c8.053 0 14.605 5.937 14.605 13.235s-6.552 13.235-14.605 13.235zm0-17.647c-2.686 0-4.868 1.978-4.868 4.412s2.182 4.412 4.868 4.412c2.686 0 4.868-1.978 4.868-4.412 0-2.435-2.182-4.412-4.868-4.412zM120.86 216.706c-8.053 0-14.604-5.937-14.604-13.235s6.551-13.235 14.604-13.235 14.604 5.937 14.604 13.235-6.551 13.235-14.604 13.235zm0-17.647c-2.686 0-4.868 1.978-4.868 4.412s2.182 4.412 4.868 4.412 4.868-1.978 4.868-4.412c0-2.435-2.182-4.412-4.868-4.412z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M179.278 291.706v4.412c0 2.433-2.184 4.412-4.868 4.412s-4.868-1.979-4.868-4.412v-4.412h9.736m9.736-8.824h-29.209v13.235c0 7.298 6.552 13.235 14.604 13.235 8.053 0 14.605-5.938 14.605-13.235v-13.235z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ffa0d2"
                },
                d: "M174.877 265.235h-.935a9.27 9.27 0 0 1-9.269-9.269v-7.933a9.27 9.27 0 0 1 9.269-9.269h.935a9.27 9.27 0 0 1 9.269 9.269v7.933c0 5.12-4.15 9.269-9.269 9.269z"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                style: {
                    fill: "#5064aa"
                },
                cx: 150.07,
                cy: 274.06,
                rx: 14.604,
                ry: 13.235
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#fab446"
                },
                d: "M145.2 177h9.736v26.471H145.2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "m120.86 221.118-9.736-8.824 5.703-5.169c8.816-7.99 20.774-12.478 33.242-12.478 12.468 0 24.426 4.489 33.242 12.478l5.703 5.169-9.736 8.824H120.86z"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                style: {
                    fill: "#ffd250"
                },
                cx: 150.07,
                cy: 212.29,
                rx: 4.868,
                ry: 4.412
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                style: {
                    fill: "#ffd250"
                },
                cx: 130.6,
                cy: 212.29,
                rx: 4.868,
                ry: 4.412
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                style: {
                    fill: "#ffd250"
                },
                cx: 169.54,
                cy: 212.29,
                rx: 4.868,
                ry: 4.412
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#c8414b"
                },
                d: "M62.44 256.41h48.681v8.823H62.44zM62.442 291.706l29.209-8.824v-8.823l-29.209 8.823z"
            })
        ]
    });
export { SvgSpain };
